var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bar",rawName:"v-bar"}]},[_c('div',[_c('p',{staticClass:"description padding",staticStyle:{"white-space":"pre-wrap"},domProps:{"innerHTML":_vm._s(_vm.currentProject.project_description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }